module.exports = __webpack_public_path__ + "img/Logo_White.3ed7fa54.svg";